var _path, _path2, _path3, _path4, _path5, _path6, _path7, _circle, _path8;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgDm = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#496e2d",
  d: "M0 85.337h512v341.326H0z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M0 224v64h512v-64z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffda44",
  d: "M0 224h512v21.337H0z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#f0f0f0",
  d: "M0 266.663h512V288H0z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M224 85.337h64v341.326h-64z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffda44",
  d: "M224 85.337h21.326v341.326H224z"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#f0f0f0",
  d: "M266.674 85.337H288v341.326h-21.326z"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 256,
  cy: 256,
  r: 81.619,
  fill: "#d80027"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  d: "M274.596 265.107c-6.071-12.142-13.963-24.449-13.963-24.449s.196-5.603.196-8.942a9.107 9.107 0 00-9.107-9.107c-4.765 0-8.668 3.661-9.067 8.321-3.746.245-6.712 3.352-6.712 7.161a7.181 7.181 0 003.864 6.368 10.344 10.344 0 016.141-5.703 9.1 9.1 0 001.451.977l1.166.559s-4.326 12.193-4.326 18.745c0 18.416 12.142 24.095 12.142 24.095v.19l-6.071 6.069h12.142v-12.142l6.071 6.072c.057-.115 11.503-7.354 6.073-18.214zM256 189.217l2.763 8.503h8.94l-7.233 5.256 2.764 8.502-7.234-5.254-7.234 5.254 2.764-8.502-7.233-5.256h8.94zm-39.254 12.755l7.232 5.254 7.233-5.254-2.762 8.502 7.233 5.255-8.939.001-2.764 8.503-2.763-8.503-8.94-.001 7.233-5.255zm-24.26 33.391h8.939l2.763-8.502 2.764 8.502h8.939l-7.232 5.255 2.764 8.503-7.235-5.254-7.233 5.253 2.763-8.502zm0 41.274l7.232-5.254-2.763-8.503 7.233 5.254 7.233-5.255-2.762 8.503 7.234 5.255-8.941.001-2.764 8.501-2.763-8.502zm24.26 33.391l2.763-8.501-7.234-5.256h8.941l2.763-8.504 2.764 8.503h8.939l-7.233 5.256 2.762 8.502-7.233-5.254zM256 322.783l-2.763-8.502h-8.94l7.233-5.256-2.764-8.503 7.234 5.254 7.233-5.254-2.763 8.503 7.233 5.255-8.94.001zm39.254-12.755l-7.232-5.254-7.233 5.255 2.762-8.503-7.234-5.255 8.94-.001 2.763-8.503 2.764 8.504h8.94l-7.233 5.256zm24.26-33.391h-8.939l-2.763 8.502-2.764-8.501h-8.941l7.234-5.256-2.764-8.502 7.235 5.254 7.232-5.254-2.762 8.502zm0-41.274l-7.232 5.255 2.763 8.502-7.233-5.254-7.234 5.255 2.763-8.503-7.234-5.254 8.941-.001 2.763-8.502 2.764 8.502zm-24.26-33.391l-2.763 8.502 7.233 5.255h-8.94l-2.762 8.504-2.765-8.503h-8.94l7.234-5.256-2.762-8.501 7.233 5.253z",
  fill: "#496e2d"
})));

export default SvgDm;